<script setup>
import { onClickOutside } from '@vueuse/core'

const show = ref(false)

const dropdown = ref(null)
onClickOutside(dropdown, () => {
  show.value = false
})
</script>

<template>
  <div
    ref="dropdown"
    class="dropdown relative w-fit">
    <button
      id="trigger"
      @click="show = !show">
      <slot
        name="trigger"
        :is-open="show" />
    </button>
    <AppCard
      v-if="show"
      class="absolute right-0 z-30 mt-1 w-fit min-w-52 overflow-hidden peer-checked:flex">
      <slot />
    </AppCard>
  </div>
</template>
